import { BoxProps, Spinner, Stack } from "@chakra-ui/react";
import { Show } from "../Show";

interface Props extends BoxProps {
  isLoading?: boolean;
}

export const Loader = ({ isLoading = false }: Props) => {
  return (
    <Show condition={isLoading}>
      <Stack
        position="fixed"
        justifyContent="center"
        alignItems="center"
        zIndex={5}
        w="full"
        h="full"
        bg="#14141491"
      >
        <Spinner size="xl" />
      </Stack>
    </Show>
  );
};
